export function getSafeTags(tags: Array<unknown>): string[] {
  const byKey = new Map<string, string>();
  tags.forEach(value => {
    if (!value) return;
    const tag = String(value).replace(/^#/, '').trim();
    if (!tag) return;
    const key = tag.toLowerCase();
    if (!byKey.has(key)) byKey.set(key, tag);
  });
  return Array.from(byKey.values());
}
